import * as React from "react";

interface HttpIconProps {
	fillColor: string;
	iconColor: string;
	style: any;
}

const HttpIcon = (props: HttpIconProps) => (
	<svg width="21px" height="10px" viewBox="0 0 21 10" version="1.1" style={props.style}>
		<defs />
		<g
			id="Page-1"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
			fontFamily="Rajdhani-Bold, Rajdhani"
			fontSize="16"
			fontWeight="bold"
		>
			<g id="Main" transform="translate(-28.000000, -105.000000)" fill="#FFFFFF">
				<g id="Group" transform="translate(22.000000, 98.000000)">
					<text id="API">
						<tspan x="5.668" y="17">
							API
						</tspan>
					</text>
				</g>
			</g>
		</g>
	</svg>
);

export default HttpIcon;



// WEBPACK FOOTER //
// ./src/components/PlatformSelector/HttpIcon.tsx